/*
  Kiddy Karat Landing Page Common Scripts
  Scoped to avoid conflicts with Dawn theme.
*/

document.addEventListener('DOMContentLoaded', function() {
  // FAQ Toggle
  window.lpToggleFAQ = function(el) {
    const item = el.parentElement;
    const isOpen = item.classList.contains('lp-open');
    document.querySelectorAll('.lp-faq-item.lp-open').forEach(i => i.classList.remove('lp-open'));
    if (!isOpen) item.classList.add('lp-open');
  };

  // Pill interactivity
  document.querySelectorAll('.lp-option-pills .lp-pill').forEach(pill => {
    pill.addEventListener('click', function() {
      const siblings = this.parentElement.querySelectorAll('.lp-pill');
      siblings.forEach(s => s.classList.remove('lp-active'));
      this.classList.add('lp-active');
    });
  });

  // Swatch interactivity
  document.querySelectorAll('.lp-swatch').forEach(sw => {
    sw.addEventListener('click', function() {
      const siblings = this.parentElement.querySelectorAll('.lp-swatch');
      siblings.forEach(s => s.style.outline = 'none');
      this.style.outline = '2.5px solid var(--lp-gold)';
      this.style.outlineOffset = '2px';
    });
  });

  // Diamond shape selection
  document.querySelectorAll('.lp-diamond-shape').forEach(shape => {
    shape.addEventListener('click', function() {
      const container = this.closest('.lp-diamond-shapes');
      container.querySelectorAll('.lp-diamond-shape').forEach(s => {
        s.style.borderColor = ''; s.style.background = ''; s.style.color = '';
      });
      this.style.borderColor = 'var(--lp-gold)';
      this.style.background = '#fdf7e8';
      this.style.color = 'var(--lp-gold-dark)';
    });
  });

  // Scroll reveal
  const revealEls = document.querySelectorAll('.lp-reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('lp-visible'), 0);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  revealEls.forEach(el => observer.observe(el));
});
